var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.samples && _vm.samples.length
    ? _c(
        "PimProductTableList",
        {
          staticClass: "pim-product-table-list--samples",
          attrs: { headers: _vm.headers },
        },
        [
          _vm.renderDecorStructureColumn
            ? _vm._l(_vm.samples, function (sample, index) {
                return _c(
                  "PimProductTableListRow",
                  { key: sample.pim_id },
                  [
                    _c(
                      "PimProductTableListColumn",
                      {
                        class: {
                          "d-none d-lg-block": !(
                            sample.image_d_src || sample.image_s_src
                          ),
                        },
                      },
                      [
                        sample.image_d_src
                          ? [
                              _c("GlobalInlineTile", {
                                attrs: {
                                  title:
                                    "<b>" +
                                    sample.title_d +
                                    "</b> " +
                                    sample.subtitle_d,
                                  "title-link": _vm.renderLinks
                                    ? sample.link_d
                                    : null,
                                  image: sample.image_d_src,
                                  imageLink: _vm.renderLinks
                                    ? sample.link_d
                                    : null,
                                  text: sample.note_d,
                                  subtitle: _vm.sampleStructures(
                                    sample.structures
                                  ),
                                },
                              }),
                            ]
                          : sample.image_s_src
                          ? [
                              _c("GlobalInlineTile", {
                                attrs: {
                                  title:
                                    "<b>" +
                                    sample.title_s +
                                    "</b> " +
                                    sample.subtitle_s,
                                  "title-link": _vm.renderLinks
                                    ? sample.link_s
                                    : null,
                                  image: sample.image_s_src,
                                  imageLink: _vm.renderLinks
                                    ? sample.link_s
                                    : null,
                                  text: sample.note_s,
                                },
                              }),
                            ]
                          : _vm._e(),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "PimProductTableListColumn",
                      [
                        sample.title_t
                          ? _c("GlobalInlineTile", {
                              attrs: {
                                title: "<b>" + sample.title_t + "</b>",
                                "title-link": _vm.renderLinks
                                  ? sample.link_t
                                  : null,
                                image: sample.image_t_src,
                                imageLink: _vm.renderLinks
                                  ? sample.link_t
                                  : null,
                                subtitle: sample.note_t,
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        sample.title_r
                          ? _c("GlobalInlineTile", {
                              attrs: {
                                title: "<b>" + sample.title_r + "</b>",
                                "title-link": _vm.renderLinks
                                  ? sample.link_r
                                  : null,
                                image: sample.image_r_src,
                                imageLink: _vm.renderLinks
                                  ? sample.link_r
                                  : null,
                                subtitle: sample.note_r,
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("PimProductTableListColumn", [
                      _c(
                        "span",
                        { staticClass: "d-lg-none" },
                        [
                          _c("GlobalInlineTile", {
                            attrs: {
                              "image-alternative": `${_vm.labelFormat}:`,
                              title: `${sample.format ? sample.format : "--"}`,
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "span",
                        { staticClass: "d-none d-lg-block" },
                        [
                          sample.format
                            ? [_vm._v(_vm._s(sample.format))]
                            : [_vm._v("--")],
                        ],
                        2
                      ),
                    ]),
                    _vm._v(" "),
                    _c("PimProductTableListColumn", [
                      _c(
                        "div",
                        {
                          staticClass:
                            "button-wrapper spaced--narrow v-center right",
                        },
                        [
                          _vm._t(
                            "actions",
                            function () {
                              return [
                                _vm._v(
                                  '\n                        Please override the "actions" slot in your template. The "item" and the "index" are passed as properties.\n                    '
                                ),
                              ]
                            },
                            { item: sample, index: index }
                          ),
                        ],
                        2
                      ),
                    ]),
                  ],
                  1
                )
              })
            : _vm._l(_vm.samples, function (sample, index) {
                return _c(
                  "PimProductTableListRow",
                  { key: sample.pim_id },
                  [
                    _c(
                      "PimProductTableListColumn",
                      [
                        sample.title_t
                          ? _c("GlobalInlineTile", {
                              attrs: {
                                title: "<b>" + sample.title_t + "</b>",
                                "title-link": _vm.renderLinks
                                  ? sample.link_t
                                  : null,
                                image: sample.image_t_src,
                                imageLink: _vm.renderLinks
                                  ? sample.link_t
                                  : null,
                                subtitle: sample.note_t,
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        sample.title_r
                          ? _c("GlobalInlineTile", {
                              attrs: {
                                title: "<b>" + sample.title_r + "</b>",
                                "title-link": _vm.renderLinks
                                  ? sample.link_r
                                  : null,
                                image: sample.image_r_src,
                                imageLink: _vm.renderLinks
                                  ? sample.link_r
                                  : null,
                                subtitle: sample.note_r,
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("PimProductTableListColumn"),
                    _vm._v(" "),
                    _c(
                      "PimProductTableListColumn",
                      [
                        _c("div", { staticClass: "d-none d-lg-block" }, [
                          _c("span", { staticClass: "d-lg-none" }, [
                            _vm._v(_vm._s(_vm.labelFormat) + ": "),
                          ]),
                          _vm._v(" "),
                          sample.format
                            ? _c("span", [_vm._v(_vm._s(sample.format))])
                            : _c("span", [_vm._v("--")]),
                        ]),
                        _vm._v(" "),
                        _c("GlobalInlineTile", {
                          staticClass: "d-lg-none",
                          attrs: {
                            title: `${_vm.labelFormat}: ${
                              sample.format
                                ? "<span>" + sample.format + "</span>"
                                : "--"
                            }`,
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("PimProductTableListColumn", [
                      _c(
                        "div",
                        {
                          staticClass:
                            "button-wrapper spaced--narrow v-center right",
                        },
                        [
                          _vm._t(
                            "actions",
                            function () {
                              return [
                                _vm._v(
                                  '\n                        Please override the "actions" slot in your template. The "item" and the "index" are passed as properties.\n                    '
                                ),
                              ]
                            },
                            { item: sample, index: index }
                          ),
                        ],
                        2
                      ),
                    ]),
                  ],
                  1
                )
              }),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }